/* import __COLOCATED_TEMPLATE__ from './recontact-window-variant.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type ReportingMetrics from 'embercom/services/reporting-metrics';

interface Arguments {
  form: any;
  currentMetric: any;
  selectMetric: (metricId: string) => void;
}

interface Signature {
  Args: Arguments;
}

const WINDOW_KEYS: Record<string, string> = {
  '24h': 'reporting.custom-reports.chart.recontact-window-variant.24h',
  '48h': 'reporting.custom-reports.chart.recontact-window-variant.48h',
  '72h': 'reporting.custom-reports.chart.recontact-window-variant.72h',
};

export default class RecontactWindowVariant extends Component<Signature> {
  @service declare reportingMetrics: ReportingMetrics;
  @service declare intl: IntlService;

  get familyMetrics() {
    return this.reportingMetrics.getMetricsByFamilyId(this.args.currentMetric.metricFamilyId);
  }

  get windowOptions() {
    return this.familyMetrics.map((metric: any) => {
      let window = this.extractWindow(metric.id);
      let key = WINDOW_KEYS[window];
      return {
        text: key ? this.intl.t(key) : window,
        value: metric.id,
      };
    });
  }

  get selectedMetricId() {
    return this.args.currentMetric.id;
  }

  extractWindow(metricId: string): string {
    if (metricId.includes('24h')) {
      return '24h';
    }
    if (metricId.includes('48h')) {
      return '48h';
    }
    if (metricId.includes('72h')) {
      return '72h';
    }
    return 'unknown';
  }

  @action
  selectWindow(metricId: string) {
    this.args.selectMetric(metricId);
  }
}
